// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".not-found[data-v-69df877b]{background:#fff;width:100vw;height:100vh;text-align:center;font-size:36px;padding-top:200px;color:#aaa}", ""]);
// Exports
module.exports = exports;
